import script from "./PwReset.vue?vue&type=script&setup=true&lang=js"
export * from "./PwReset.vue?vue&type=script&setup=true&lang=js"

import "./PwReset.vue?vue&type=style&index=0&id=5908b0ca&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5908b0ca"]])

export default __exports__